<template>
    <div class="container">
        <CdsMenu @menuSelect="menuSelect"/>
        <div>
            <div class="introduction" >
                <div class="introductionTitle">
                    <h1 data-aos="fade-up">SciSmart科研项目管理平台</h1>
                    <div data-aos="fade-up"></div>
                    <div data-aos="fade-up">SciSmart 科研项目管理平台面向科研项目流程管理场景，可对科研项目相关人员、预算经费、项目进度、绩效考核等信息进行归集与管控，支持项目类型、研究领域、审核进度等维度管理，支撑科研工作从项目申报至档案归档的业务链路追溯与管理，助力科研工作实现规范化、流程化、一体化运行，助力提升研发管理水平与工作效率。
                    </div>
                </div>
                <div data-aos="zoom-in">
                    <img :src="require('@/assets/img/database/sciSmart/introductionTitle.png')" alt="" >
                </div>
            </div>
            <div class="function">
                <div class="functionTitle" data-aos="fade-up">功能模块</div>
                <div class="functionList">
                    <div data-aos="fade-up">项目管理</div>
                    <div data-aos="fade-up">考核奖励</div>
                    <div data-aos="fade-up">经费管理</div>
                    <div data-aos="fade-up">统计分析</div>
                    <div data-aos="fade-up">成果管理</div>
                    <div data-aos="fade-up">平台设置</div>
                </div>
            </div>
            <div class="architecture">
                <div class="architectureTitle" data-aos="fade-up">系统架构</div>
                <div class="architectureContent">
                    <div class="architectureList" data-aos="fade-right">
                        <div>
                            <div>1<i class="el-icon-arrow-right"></i>项目管理</div>
                            <div><i class="el-icon-folder-opened"></i></div>
                        </div>
                        <div>
                            <div><div><span style="display: inline-block;margin-right: 5px;color: #00377d">´</span>项目总览看板</div></div>
                            <div><div><span style="display: inline-block;margin-right: 5px;color: #00377d">´</span>安全性管理</div></div>
                            <div><div><span style="display: inline-block;margin-right: 5px;color: #00377d">´</span>项目预警</div></div>
                            <div><div><span style="display: inline-block;margin-right: 5px;color: #00377d">´</span>质控管理</div></div>
                            <div><div><span style="display: inline-block;margin-right: 5px;color: #00377d">´</span>随访管理</div></div>
                            <div><div><span style="display: inline-block;margin-right: 5px;color: #00377d">´</span>偏倚管理</div></div>
                        </div>
                    </div>
                    <div class="architectureList"  data-aos="fade-right">
                        <div>
                            <div>2<i class="el-icon-arrow-right"></i>项目协作</div>
                            <div><i class="el-icon-star-off"></i></div>
                        </div>
                        <div>
                            <div>
                                <div>人员筛选</div>
                                <div>人员智能筛选</div>
                                <div>可量化标准</div>
                                <div>精选顶配组合</div>
                            </div>
                            <div>
                                <div>成员管理</div>
                                <div>成员基本信息</div>
                                <div>科研信息</div>
                                <div>学术任职信息</div>
                            </div>
                            <div>
                                <div>专家管理</div>
                                <div>专家分组</div>
                                <div>专家新增及遴选</div>
                                <div style="padding-bottom: 10px">支持多条件查询相应专家信息</div>
                            </div>
                            <div>
                                <div>文档共享</div>
                                <div>上传相应文件附件配置不同文件分类支持自定义排序</div>
                            </div>
                        </div>
                    </div>
                    <div class="architectureList"  data-aos="fade-left">
                        <div>
                            <div>4<i class="el-icon-arrow-right"></i>项目执行</div>
                            <div><i class="el-icon-tickets"></i></div>
                        </div>
                        <div>
                            <div style="border-top: none;border-left: none;">
                                <div>项目立项</div>
                                <div>手动/导入创建项目</div>
                                <div>自定义配置</div>
                                <div>各项目的不同分类</div>
                            </div>
                            <div style="border-top: none;border-left: none;">
                                <div>项目预算</div>
                                <div>手动/导入创建项目</div>
                                <div>可按科目配置</div>
                                <div>预算标准</div>
                            </div>
                            <div style="border-top: none;border-left: none;">
                                <div>项目变更</div>
                                <div>变更记录永久</div>
                                <div>保存可追溯</div>
                            </div>
                            <div style="border-top: none;border-left: none;border-right: none;">
                                <div>项目中检</div>
                                <div>中检记录永久</div>
                                <div>保存可追溯</div>
                            </div>
                            <div style="border-top: none;border-left: none;">
                                <div>合同签审</div>
                                <div>支持批量审核</div>
                                <div>新增、导入和导出</div>
                                <div>永久保存且可追溯</div>
                            </div>
                            <div style="border-top: none;border-left: none;">
                                <div>合同预算</div>
                                <div>针对不同的合同</div>
                                <div>及科目进行预算</div>
                                <div>标准配置</div>
                            </div>
                            <div style="border-top: none;border-left: none;">
                                <div>合同变更</div>
                                <div>提交变更后退行审核</div>
                                <div>支持导出和统计</div>
                            </div>
                            <div style="border-top: none;border-left: none;border-right: none;">
                                <div>合同备案</div>
                                <div>自定义添加合同</div>
                                <div>转出信息</div>
                                <div>支持导出和统计</div>
                            </div>
                            <div style="border-top: none;border-bottom: none;border-left: none;">
                                <div>项目申报</div>
                                <div>永久保留申报记录</div>
                                <div>便于快速进行追溯</div>
                            </div>
                            <div style="border-top: none;border-bottom: none;border-left: none;">
                                <div>项目评审</div>
                                <div>评审进度可视化</div>
                                <div>评审结果可邮件</div>
                                <div>/微信/短信通知</div>
                            </div>
                            <div style="border:none">
                                <div>项目结题</div>
                                <div>中险成果信息自动导入</div>
                                <div>可新增成果信息</div>
                            </div>
                        </div>
                    </div>
                    <div class="architectureList"  data-aos="fade-right">
                        <div>
                            <div>3<i class="el-icon-arrow-right"></i>团队沟通</div>
                            <div><i class="el-icon-user"></i></div>
                        </div>
                        <div>
                            <div>
                                <img :src="require('@/assets/img/database/sciSmart/architecture3.png')" alt="">
                            </div>
                            <div>
                                <div><span style="display: inline-block;margin-right: 5px;color: #00377d">´</span>多端使用</div>
                            </div>
                            <div>
                                <div><span style="display: inline-block;margin-right: 5px;color: #00377d">´</span>及时推送</div>
                            </div>
                        </div>
                    </div>
                    <div class="architectureList"  data-aos="fade-left">
                        <div>
                            <div>5<i class="el-icon-arrow-right"></i>管理平台</div>
                            <div><i class="el-icon-s-operation"></i></div>
                        </div>
                        <div>
                            <div>
                                <div><span style="display: inline-block;margin-right: 5px;color: #00377d">´</span>项目管理</div>
                            </div>
                            <div>
                                <div><span style="display: inline-block;margin-right: 5px;color: #00377d">´</span>经费管理</div>
                            </div>
                            <div>
                                <div><span style="display: inline-block;margin-right: 5px;color: #00377d">´</span>成果管理</div>
                            </div>
                            <div>
                                <div><span style="display: inline-block;margin-right: 5px;color: #00377d">´</span>考核奖励</div>
                            </div>
                            <div>
                                <div><span style="display: inline-block;margin-right: 5px;color: #00377d">´</span>统计分析</div>
                            </div>
                            <div>
                                <div><span style="display: inline-block;margin-right: 5px;color: #00377d">´</span>平台设置</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-for="item in content" class="content">
                <div class="itemTitle"  data-aos="fade-up">{{item.title}}</div>
                <div v-for="list in item.list">
                    <div class="listTitle"  data-aos="fade-up">{{list.name}}</div>
                    <div v-for="arr in list.item" class="arr"  data-aos="fade-up">
                        {{arr}}
                    </div>
                    <div class="pic"  data-aos="zoom-in">
                        <img :src="list.pic" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CdsMenu from "../../components/CdsMenu";
export default {
	components: {CdsMenu},
	data() {
		return {
            content:[
                {
                    title:'项目管理',
                    list:[
                        {
                            name:'纵向项目',
                            item:[
                                '•及时发布：可手动输入或快速导入项目信息，进行统一审核，快速发布项目信息；',
                                '•合理预算：可针对不同的科目需求配置相应的项目预算标准，并进行预算添加、提交及审核；',
                                '•风险管控：通过质控管理、安全性管理、偏倚管理以及项目中检等管控项目风险。',
                            ],
                            pic:require('@/assets/img/database/sciSmart/content0.png'),
                        },
                        {
                            name:'横向项目',
                            item:[
                                '•合同管理：可针对进账合同进行统一备案、批量审核、提交变更、转出合同备案等，支持导出和统计；',
                                '•合理预算：支持进账合同预算提交及审核，根据项目情况评定项目预算进行审核；',
                                '•统一设置：可对合同类别进行统一设置及管理，支持新增编号生成规则、经费提取方案、项目分类等。',
                            ],
                            pic:require('@/assets/img/database/sciSmart/content3.png'),
                        },
                        {
                            name:'院级项目',
                            item:[
                                '•快速申报：填写申报计划内容，上传申报指南、申请书模板及正文模板等，精准筛选申报人员后进行项目推送；',
                                '•合理预算：支持项目预算管理，可针对项目进行项目预算的添加、提交及审核；',
                                '•风险管控：支持项目随访、质控、偏倚等的统一管理；针对项目执行过程可进行项目中检，提交项目中检进行审核。',
                            ],
                            pic:require('@/assets/img/database/sciSmart/content4.png'),
                        },
                        {
                            name:'其他',
                            item:[
                                '•信息检索：便捷查阅待审核项目、退回项目信息，项目结项时间等；',
                                '•精准筛选：支持通过自定义多条件组合查询匹配相应符合项目申报要求的人员；',
                                '•预算设置：针对项目的不同设置预算方案，制定项目经费类型，便于统一管理项目预算。',
                            ],
                            pic:require('@/assets/img/database/sciSmart/content5.png'),
                        }
                    ]
                },
                {
                    title:'经费管理',
                    list:[
                        {
                            name:'',
                            item:[
                                '•入账管理：对银行到款进行统一管理，根据项目情况进行认领金额审核，支持经费卡入账管理，自定义添加入账方案；',
                                '•执行率管理：实时查看项目立项年度、执行周期、到账率及执行率，也支持从科室、项目及科目维度查看；',
                                '•经费预警：针对项目分类自定义配置执行周期、预警条件，发送方式及对象、内容等，对预警信息进行统一管理。',
                            ],
                            pic:require('@/assets/img/database/sciSmart/content6.png'),
                        },
                    ]
                },
                {
                    title:'成果管理',
                    list:[
                        {
                            name:'',
                            item:[
                                '•成果管理：对各类成果进行统一管理与批量审核，可自定义配置期刊级别与相应期刊源，助力提升成果申报效率；',
                                '•专利预警：包括专利年费预警等，自定义配置预警发送时间、发送方式及对象、内容等，为专利维护提供支撑；',
                                '•学术交流：自定义添加会议、讲座、人员派遣等信息，支持导出与统计，实现学术交流信息的集中管理。',
                            ],
                            pic:require('@/assets/img/database/sciSmart/content7.png'),
                        },
                    ]
                },
                {
                    title:'考核奖励',
                    list:[
                        {
                            name:'',
                            item:[
                                '•考核标准：针对不同岗位进行标准设置，支持以向导形式进行考核配置，针对不同的项目类型配置相应的考核方案；',
                                '•奖励方案：自定义配置考核对象、奖励范围、奖励细则等，并可对考核奖励进行统一管理；',
                                '•奖励确认：支持对奖励确认进行统一管理，可记录相应的反馈人、反馈内容及时间等，避免繁琐的纸质文件流程。',
                            ],
                            pic:require('@/assets/img/database/sciSmart/content8.png'),
                        },
                    ]
                },
                {
                    title:'统计分析',
                    list:[
                        {
                            name:'',
                            item:[
                                '•多维统计：分项目统计及基础统计，多维度筛选展示客观统计数据；',
                                '•图形可选：多种常用科研统计图形报表可选，根据统计数据内容灵活选配；',
                                '•决策支持：直观展示的统计图标可谓项目进度管控与管理决策提供信息支持。',
                            ],
                            pic:require('@/assets/img/database/sciSmart/content9.png'),
                        },
                    ]
                },
                {
                    title:'平台设置',
                    list:[
                        {
                            name:'',
                            item:[
                                '•人员管理：对平台内科研人员进行统一管理，可对专家分组，院内及院外专家新增及遴选管理；',
                                '•机构管理：可对组织结构及研究机构进行统一管理，汇总相应的教育部统计信息，且可进行导出及统计；',
                                '•共享管理：支持文档共享管理，可自定义配置文件分类，支持自定义排序，并可对导入导出日志进行统一管理。',
                            ],
                            pic:require('@/assets/img/database/sciSmart/content10.png'),
                        },
                    ]
                }
            ]
        }
	},
    methods:{
	    menuSelect(src){
	        this.$emit('menuSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .introduction{
        width: 1032px;
        margin: 0 5% 0;
        padding-top: 125px;
        display: flex;
        justify-content: space-between;
        .introductionTitle{
            width: 509px;
            padding-top: 84px;
            h1{
                font-size: 19px;
            }
            &>div:nth-child(2){
                width: 65px;
                height: 2px;
                background: #006efd;
                margin: 13px 0 50px 0px;
            }
            &>div:nth-child(3),&>div:nth-child(4){
                font-size: 15px;
                letter-spacing: 1px;
                line-height: 25px;
                text-indent: 2em;
            }
        }
    }
    .function{
        width: 100%;
        background: url("../../assets/img/database/sciSmart/functionBg.png") ;
        background-size: 100%;
        height: 512px;
        padding-top: 70px;
        box-sizing: border-box;
        .functionTitle{
            width: 303px;
            height: 67px;
            margin: 0 auto 100px;
            text-align: center;
            font-size: 30px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 2px;
            color: #ffffff;
        }
        .functionList{
            width: 827px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            div{
                width: 318px;
                height: 48px;
                border-radius: 10px;
                border: solid 1px #ffffff;
                line-height: 48px;
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 4px;
                color: #dfefff;
                margin-bottom: 30px;
                text-align: center;
            }
        }
    }
    .architecture{
        .architectureTitle{
            width: 186px;
            height: 59px;
            line-height: 59px;
            font-size: 30px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 2px;
            color: #ed1c24;
            margin: 50px auto 0;
            background: url("../../assets/img/database/sciSmart/architectureTitle.png");
            text-align: center;
        }
        .architectureContent{
            width: 887px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin: 50px auto 0;
            .architectureList{
                border: 1px solid #9fc9e4;
                border-radius: 10px;
                &>div:nth-child(1){
                    background-image: linear-gradient(#389dd8,#005e92);
                    font-size: 16px;
                    padding: 0 20px;
                    line-height: 28px;
                    height: 28px;
                    border-radius: 10px;
                    display: flex;
                    justify-content: space-between;
                    div{
                        color: #fff;
                        i{
                            color: #fff;
                        }
                    }
                }
                &>div:nth-child(2){
                    padding: 17px 10px;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    &>div{
                        font-size: 12px;
                        margin-bottom: 10px;
                        &>div:nth-child(1){
                            font-weight: bold;
                            line-height: 36px;
                        }
                        &>div:nth-child(2){

                        }
                    }
                }
            }
            .architectureList:nth-child(1),.architectureList:nth-child(2){
                width: 200px;
            }
            .architectureList:nth-child(1){
                &>div:nth-child(2){
                    &>div{
                        width: 50%;
                    }
                    &>div:nth-child(2n){
                        width: 40%;
                    }
                }
            }
            .architectureList:nth-child(2){
                &>div:nth-child(2){
                    &>div:nth-child(3){
                      width: 100%;
                       border-top: 1px solid #f1f8f9;
                       border-bottom: 1px solid #f1f8f9;
                        padding: 5px 0;
                    }
                }
            }
            .architectureList:nth-child(3){
                width: 460px;
                &>div:nth-child(2){
                    display: flex;
                    justify-content: flex-start;
                    &>div{
                        width: 25%;
                        border: 1px solid #f1f8f9;
                        box-sizing: border-box;
                        margin-bottom: 0;
                        padding: 5px 0 5px 5px;
                    }
                }
            }
            .architectureList:nth-child(4){
                width: 415px;
                margin-top: 12px;
                &>div:nth-child(2){
                    margin-bottom: 0;
                    display: flex;
                    justify-content: space-between;
                    padding-right: 30px;
                    div{
                        margin-bottom: 0;
                        div:nth-child(1){
                            line-height: 26px;
                        }
                    }
                }
            }
            .architectureList:nth-child(5){
                width: 460px;
                margin-top: 12px;
                &>div:nth-child(2){
                     margin-bottom: 0;
                    div{
                         margin-bottom: 0;
                    }
                    /*display: flex;*/
                    /*justify-content: flex-start;*/
                    /*&>div{*/
                    /*    width: 25%;*/
                    /*    border: 1px solid #f1f8f9;*/
                    /*    box-sizing: border-box;*/
                    /*    margin-bottom: 0;*/
                    /*    padding: 5px 0 5px 5px;*/
                    /*}*/
                }
            }
        }
    }
    .content{
        width: 960px;
        margin: 0 auto;
        .itemTitle{
            width: 113px;
            height: 25px;
            background-color: #006efd;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 25px;
            letter-spacing: 2px;
            color: #ffffff;
            text-align: center;
            margin-bottom: 30px;
            margin-top: 100px;
        }
        .listTitle{
            font-size: 15px;
            font-stretch: normal;
            line-height: 25px;
            letter-spacing: 1px;
            color: #000000;
            font-weight: bold;
        }
        .arr{
            margin-top: 10px;
            font-size: 15px;
            font-weight: normal;
            letter-spacing: 1px;
            color: #000000;
        }
        .pic{
            text-align: center;
            margin: 36px 0 63px 0;
        }
    }
</style>
